// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-header.mobile {
    display: none;
  }
}
@media (max-width: 992px) {
  ion-header.desktop {
    display: none;
  }
}

@media (max-width: 992px) {
  app-header-desktop {
    display: none;
  }
}

.right-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.table-chip {
  height: 24px;
  padding-inline: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.46px solid var(--ion-color-primary);
  border-radius: 2px;
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.main-header {
  position: relative;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 28px;
  border-bottom: 0.5px solid #a3a3a3;
}
.main-header .logo {
  height: 70px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-header .main-right {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
.main-header .main-right .order-chip {
  display: none;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-right: 12px;
  margin-left: 10px;
  position: relative;
}
@media (min-width: 991px) {
  .main-header .main-right .order-chip {
    display: flex;
  }
}
.main-header .main-right .order-chip__busket {
  height: 100%;
  --icon-color: #1e1e1c;
  height: 30px;
  width: 30px;
}
.main-header .main-right .order-chip__quantity {
  position: absolute;
  top: -8px;
  right: -2px;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background-color: #ea4949;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-header .main-right .order-chip__quantity .number {
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: #fff;
}

.second-header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  border-bottom: 0.5px solid #a3a3a3;
}
.second-header .center-content h3 {
  font-family: AppFontSemiBold;
  font-size: 31.14px;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 5px;
}
.second-header .center-content .change-location {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.second-header .center-content .change-location ion-icon {
  height: 27px;
  width: 22px;
}
.second-header .center-content .change-location p {
  font-family: AppFontSemiBold;
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
}

.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  padding: 0 10px;
}
.main_row .item_row:last-child {
  padding-bottom: 400px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    padding: 0 0px 0 10px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main_row .order-col {
  padding-top: 23px;
}

.item-col {
  margin-bottom: 12px;
}
@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-family: AppFont;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .category-row h2 {
    font-size: 22px;
    line-height: 33.01px;
  }
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
  overflow: auto;
  flex-grow: 1;
}

.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}

.main-content::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.category-list {
  display: flex;
  overflow-x: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  scroll-behavior: smooth;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list ion-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  height: 36px;
  width: max-content;
  margin: 0 3px;
  padding: 0 8px;
  background: #ffffff;
  border: 0.5px solid #1c63b7;
  border-radius: var(--radius-default);
  color: #333333;
  opacity: 1;
}
.category-list ion-chip:first-child {
  margin-left: 0;
}
.category-list ion-chip:last-child {
  margin-right: 0;
}
.category-list ion-chip.selected {
  background: var(--ion-color-primary) !important; /* Gold */
  color: #ffffff !important;
  border-color: #1c63b7;
}
.category-list ion-chip.selected p {
  font-family: AppFontMedium;
  color: #ffffff !important;
}
.category-list ion-chip p {
  font-family: AppFont;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}

.category-list-container-col {
  padding: 16px;
  border-bottom: 0.8px solid #404040;
}
@media (min-width: 991px) {
  .category-list-container-col {
    border-bottom: 0.5px solid #a3a3a3;
  }
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 20px;
}
.category-row h2 {
  font-family: AppFontBold, sans-serif; /* Bold Condensed */
  font-size: 32px; /* Large title */
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
  color: #000000;
  margin: 0;
}

.venue_info_block {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between; /* Left, Center, Right */
  padding: 35px 16px 0;
  margin-bottom: 10px;
  position: relative;
  background: #ffffff;
}
.venue_info_block .left-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
.venue_info_block .left-icon ion-icon {
  height: 100%;
  width: 100%;
}
.venue_info_block .center-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -20%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}
.venue_info_block .center-content h3 {
  font-family: AppFontSemiBold, sans-serif; /* Condensed Bold */
  font-size: 24px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.venue_info_block .center-content .change-location {
  font-family: AppFont;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
  cursor: pointer;
}
.venue_info_block app-burger-btn {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}

.filters_section {
  z-index: 99;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  transition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}
.filters_section.show-filters {
  z-index: 999;
  opacity: 1;
  min-height: 200px;
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.max-height-100 {
  max-height: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.fixed-notification {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 50, 200, 0.8588235294);
  color: var(--color-white);
  font-family: AppFontMedium;
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 70px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAQA;EACC,gBAAA;AAPD;ACDE;EDUD;IAEE,aAAA;EAPD;AACF;ACAE;EDSD;IAEE,aAAA;EAPD;AACF;;ACLE;EDgBF;IAEE,aAAA;EARA;AACF;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AARD;;AAWA;EACC,YAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EAEA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;AATD;;AAYA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AATD;AAWC;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AATF;AAYC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAVF;AAYE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAVH;AC3EE;ED8EA;IAUE,aAAA;EATF;AACF;AAWG;EACC,YAAA;EAEA,qBAAA;EACA,YAAA;EACA,WAAA;AAVJ;AAgBG;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdJ;AAgBI;EACC,4BAAA;EACA,eAAA;EACA,WAAA;AAdL;;AAqBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,kCAAA;AAnBD;AAsBE;EACC,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AApBH;AAuBE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AArBH;AAsBG;EACC,YAAA;EACA,WAAA;AApBJ;AAsBG;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;AApBJ;;AA0BA;EACC,YAAA;AAvBD;AA6BC;EACC,mBAAA;AA3BF;AA4BE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AA5BH;AA6BG;EACC,WAAA;EACA,kBAAA;AA3BJ;AA6BG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AA3BJ;AA8BG;EACC,eAAA;AA5BJ;AA+BG;EACC,oCAAA;EACA,WAAA;AA7BJ;AA8BI;EACC,YAAA;AA5BL;AAiCC;EACC,WAAA;EACA,WAAA;EACA,mBAAA;AA/BF;AAiCC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;AAhCF;AAmCC;EACC,eAAA;AAjCF;AAmCE;EACC,qBAAA;AAjCH;AC1ME;EDuOD;IAQE,qBAAA;EAjCD;AACF;AAoCC;EACC,kBAAA;EACA,gBAAA;EACA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;AAnCF;AAsCC;EACC,iBAAA;AApCF;;AAwCA;EACC,mBAAA;AArCD;AC9NE;EDkQF;IAGE,kBAAA;IAEA,qBAAA;EApCA;AACF;;AAuCA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AApCD;AC5OE;ED2QF;IAQE,2BAAA;IACA,kBAAA;EAnCA;AACF;AAoCC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAlCF;AC1PE;EDsRD;IASE,eAAA;IACA,oBAAA;EAjCD;AACF;;AAqCA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAlCD;AAmCC;EACC,wCAAA;EACA,qBAAA;AAjCF;AAmCC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;AAjCF;AAkCE;EACC,SAAA;AAhCH;;AAqCA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAlCD;AAmCC;EACC,WAAA;AAjCF;;AAqCA;EACC,YAAA;EACA,aAAA;AAlCD;AAmCC;EACC,WAAA;AAjCF;;AAqCA;EACC,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAlCD;;AAqCA;EACC,aAAA;AAlCD;;AAoCA;EACC,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAjCD;;AAoCA;EACC,aAAA;EACA,gBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,uBAAA;AAjCD;AAmCC;EACC,aAAA;AAjCF;AAoCC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;EACA,cAAA;EACA,UAAA;AAlCF;AAoCE;EACC,cAAA;AAlCH;AAqCE;EACC,eAAA;AAnCH;AAsCE;EACC,+CAAA,EAAA,SAAA;EACA,yBAAA;EACA,qBAAA;AApCH;AAsCG;EACC,0BAAA;EACA,yBAAA;AApCJ;AAwCE;EACC,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAtCH;;AA2CA;EACC,aAAA;EACA,kCAAA;AAxCD;ACrXE;ED2ZF;IAKE,kCAAA;EAvCA;AACF;;AA0CA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAvCD;AAyCC;EACC,oCAAA,EAAA,mBAAA;EACA,eAAA,EAAA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AAvCF;;AA2CA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA,EAAA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAxCD;AA0CC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAxCF;AA0CE;EACC,YAAA;EACA,WAAA;AAxCH;AA4CC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA1CF;AA4CE;EACC,wCAAA,EAAA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,kBAAA;AA5CH;AA+CE;EACC,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,iCAAA;UAAA,8BAAA;EAEA,eAAA;AA9CH;AAkDC;EACC,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAhDF;;AAmDA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,iEAAA;EACA,2DAAA;EACA,6BAAA;EACA,4BAAA;AAhDD;AAiDC;EACC,YAAA;EACA,UAAA;EACA,iBAAA;AA/CF;;AAkDA;EACC,aAAA;EACA,uBAAA;EACA,iBAAA;AA/CD;;AAiDA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9CD;;AAiDA;EACC,gBAAA;AA9CD;;AAiDA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YAtiB0B;EAuiB1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AAlDD;AAoDC;EACC,QAAA;EAGA,oDAAA;AAlDF;AAsDE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AArDH;AAwDE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAtDH;AAuDG;EACC,YAAA;EACA,WAAA;AArDJ;;AA0DA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AAvDD;AAyDC;EACC,UAAA;EACA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AAvDF;AC/iBE;EDmlBF;IAsBE,YAAA;IACA,eAAA;EAtDA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n}\n\n$container_padding_top: 30px;\n$order_basket_block_width: 400px;\n\nion-header {\n\tbox-shadow: none;\n\n\t&.mobile {\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t&.desktop {\n\t\t@include mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\napp-header-desktop {\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n}\n\n.right-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n}\n\n.table-chip {\n\theight: 24px;\n\tpadding-inline: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 0.46px solid var(--ion-color-primary);\n\tborder-radius: 2px;\n\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 0.04em;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-primary);\n}\n\n.main-header {\n\tposition: relative;\n\theight: 70px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 28px;\n\tborder-bottom: 0.5px solid #a3a3a3;\n\n\t.logo {\n\t\theight: 70px;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n\n\t.main-right {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tmargin-left: auto;\n\n\t\t.order-chip {\n\t\t\tdisplay: none;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\theight: 30px;\n\t\t\tmargin-right: 12px;\n\t\t\tmargin-left: 10px;\n\t\t\tposition: relative;\n\n\t\t\t@include desktop {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\n\t\t\t&__busket {\n\t\t\t\theight: 100%;\n\n\t\t\t\t--icon-color: #1e1e1c;\n\t\t\t\theight: 30px;\n\t\t\t\twidth: 30px;\n\t\t\t\t// @include desktop {\n\t\t\t\t// \tpointer-events:  none;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\t&__quantity {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -8px;\n\t\t\t\tright: -2px;\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tbackground-color: #ea4949;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.number {\n\t\t\t\t\tfont-family: AppFontSemiBold;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.second-header {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\theight: 120px;\n\tborder-bottom: 0.5px solid #a3a3a3;\n\n\t.center-content {\n\t\th3 {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 31.14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.04em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\n\t\t.change-location {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tgap: 8px;\n\t\t\tion-icon {\n\t\t\t\theight: 27px;\n\t\t\t\twidth: 22px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-family: AppFontSemiBold;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 116%;\n\t\t\t\tletter-spacing: 0.02em;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\ttext-decoration: underline;\n\t\t\t\ttext-decoration-style: solid;\n\t\t\t\ttext-decoration-offset: 0%;\n\t\t\t\ttext-decoration-thickness: 0%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.main_row {\n\theight: 100%;\n\n\t// @include tablet {\n\t//   height: 90%;\n\t// }\n\n\t.category_col {\n\t\tbackground: #f3f3f3;\n\t\t.category_item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\tpadding: 10px 5px 10px 10px;\n\t\t\tmargin-top: 1.5px;\n\n\t\t\tbackground: #f3f3f3;\n\t\t\tborder-radius: 0px;\n\n\t\t\ttransition: all 0.3s;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\tborder-bottom: 1.5px solid #4f614f1a;\n\t\t\tion-img {\n\t\t\t\twidth: 60px;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t}\n\n\t\t\t&:first-of-type {\n\t\t\t\tmargin-top: 0px;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: #fff;\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.border_top_line {\n\t\twidth: 100%;\n\t\theight: 3px;\n\t\tbackground: #d9d9d9;\n\t}\n\t.category_name {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 17px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\n\t\tpadding: 30px 0px 20px 7px;\n\t}\n\n\t.item_row {\n\t\tpadding: 0 10px;\n\n\t\t&:last-child {\n\t\t\tpadding-bottom: 400px;\n\t\t}\n\n\t\t@include desktop {\n\t\t\tpadding: 0 0px 0 10px;\n\t\t}\n\t}\n\n\t.catalog_col {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100%;\n\t}\n\n\t.order-col {\n\t\tpadding-top: 23px;\n\t}\n}\n\n.item-col {\n\tmargin-bottom: 12px;\n\t@include desktop {\n\t\tmargin-bottom: 0px;\n\t\t// padding-inline: 13px;\n\t\tpadding: 0px 7px 13px;\n\t}\n}\n\n.category-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-block: 23px;\n\n\t@include desktop {\n\t\tjustify-content: flex-start;\n\t\tpadding-left: 13px;\n\t}\n\th2 {\n\t\tfont-family: AppFont;\n\t\tfont-size: 20px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0px;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t\t@include desktop {\n\t\t\tfont-size: 22px;\n\t\t\tline-height: 33.01px;\n\t\t}\n\t}\n}\n\n.search_col {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-searchbar {\n\t\t--box-shadow: 0px 0px 42px 0px #00000012;\n\t\t--border-radius: 10px;\n\t}\n\t.open_filters {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 42px;\n\t\theight: 42px;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\tion-icon {\n\t\t\tzoom: 1.3;\n\t\t}\n\t}\n}\n\n.footer-btn-desktop {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 40%;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n\n.order_list_row {\n\theight: 100%;\n\tdisplay: flex;\n\tapp-order-content {\n\t\twidth: 100%;\n\t}\n}\n\n.main-content {\n\t--padding-start: 0%;\n\t--padding-end: 0%;\n\toverflow: auto;\n\tflex-grow: 1;\n}\n\n.main-content::part(scroll)::-webkit-scrollbar {\n\tdisplay: none;\n}\n.main-content::part(scroll) {\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n}\n\n.category-list {\n\tdisplay: flex;\n\toverflow-x: auto;\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n\tscroll-behavior: smooth;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\tion-chip {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex: 0 0 auto;\n\t\theight: 36px;\n\t\twidth: max-content;\n\t\tmargin: 0 3px;\n\t\tpadding: 0 8px;\n\t\tbackground: #ffffff;\n\t\tborder: 0.5px solid #1c63b7;\n\t\tborder-radius: var(--radius-default);\n\t\tcolor: #333333;\n\t\topacity: 1;\n\n\t\t&:first-child {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-primary) !important; /* Gold */\n\t\t\tcolor: #ffffff !important;\n\t\t\tborder-color: #1c63b7;\n\n\t\t\tp {\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tcolor: #ffffff !important;\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 13px;\n\t\t\tleading-trim: NONE;\n\t\t\tline-height: 150%;\n\t\t\tletter-spacing: 0.04em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n}\n\n.category-list-container-col {\n\tpadding: 16px;\n\tborder-bottom: 0.8px solid #404040;\n\n\t@include desktop {\n\t\tborder-bottom: 0.5px solid #a3a3a3;\n\t}\n}\n\n.category-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-top: 30px;\n\tpadding-bottom: 20px;\n\n\th2 {\n\t\tfont-family: AppFontBold, sans-serif; /* Bold Condensed */\n\t\tfont-size: 32px; /* Large title */\n\t\tline-height: 1;\n\t\tletter-spacing: 1px;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #000000;\n\t\tmargin: 0;\n\t}\n}\n\n.venue_info_block {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between; /* Left, Center, Right */\n\tpadding: 35px 16px 0;\n\tmargin-bottom: 10px;\n\tposition: relative;\n\tbackground: #ffffff;\n\n\t.left-icon {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 24px;\n\t\theight: 24px;\n\n\t\tion-icon {\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.center-content {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -20%);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-grow: 1;\n\n\t\th3 {\n\t\t\tfont-family: AppFontSemiBold, sans-serif; /* Condensed Bold */\n\n\t\t\tfont-size: 24px;\n\t\t\tleading-trim: NONE;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.04em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\n\t\t.change-location {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 13px;\n\t\t\tleading-trim: NONE;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-decoration: underline;\n\t\t\ttext-decoration-style: solid;\n\t\t\ttext-decoration-offset: 0%;\n\t\t\ttext-decoration-thickness: 0%;\n\t\t\ttext-decoration-skip-ink: auto;\n\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\tapp-burger-btn {\n\t\t--padding-start: 0;\n\t\t--padding-end: 0;\n\t\t--padding-top: 0;\n\t\t--padding-bottom: 0;\n\t}\n}\n.filters_section {\n\tz-index: 99;\n\tposition: absolute;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: white;\n\tmin-height: 0px;\n\topacity: 0;\n\tz-index: -1;\n\ttransition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n\tbox-shadow: 0px 0px 20px 0px #4f614f26;\n\tborder-top-right-radius: 16px;\n\tborder-top-left-radius: 16px;\n\t&.show-filters {\n\t\tz-index: 999;\n\t\topacity: 1;\n\t\tmin-height: 200px;\n\t}\n}\n.filter-toggle {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px 0px;\n}\n.no_items {\n\twidth: 100%;\n\theight: 70vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.max-height-100 {\n\tmax-height: 100%;\n}\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t\tright: 0;\n\t\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t\t.close_basket_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tpadding-left: 20px;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\tcolor: var(--ion-color-black);\n\t\t\tbackground: #f9f9f9;\n\t\t}\n\n\t\t.close_basket_img_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: #d9d9d9;\n\t\t\tpadding: 0 16.5px;\n\t\t\theight: 55px;\n\t\t\twidth: 55px !important;\n\t\t\t.close_basket_img {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n}\n.fixed-notification {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: #0032c8db;\n\tcolor: var(--color-white);\n\tfont-family: AppFontMedium;\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tpadding: 20px;\n\tmin-height: 0px;\n\theight: 0px;\n\ttransition: opacity 0.3s ease-in-out;\n\topacity: 0;\n\n\t&.show-item {\n\t\topacity: 1;\n\t\theight: fit-content;\n\t\tmin-height: fit-content;\n\t}\n\t@include mobile {\n\t\tbottom: 70px;\n\t\tfont-size: 14px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
